var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"lpIconfont",class:_vm.icon,on:{"click":_vm.handleIconClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }